<template>
  <div style="display: none"></div>
</template>

<script>
import { mapGetters } from 'vuex';
import Undo from './undo.js';

export default {
  name: 'Undo',
  data() {
    return {
      type: '',               // 当前应该调用那个栈 值('' 'Path')
      stack: null,            // 画布栈
      editCommand: null,
      stackPath: null,        // 针对设置路径动画的撤销
      editCommandPath: null,
      canUndo: false,
      canRedo: false
    }
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'SelectScenes_Msg',
      'SelectSprites_Msg'
    ]),
    ...mapGetters({
      "soundHandle": "addSoundtrack/getPlayHandle"
    })
  },
  mounted () {
    this.$bus.on('undo_redo_clear', this.onUndoRedoClear);
    // 画布栈入栈事件
    eve.on("undo_redo", this.inStack);
    // 调用撤销和恢复事件
    this.$bus.on('undo_redo_vue', (data) => {
      this[data.type + this.type]()
    });
    // 创建画布栈
    this.stack = new Undo.Stack();
    this.editCommand = Undo.Command.extend({
      constructor: function(type, data, fn) {
        this.type = type;
        this.data = data;
        this.fn = fn;
      },
      execute: function() {},
      undo: function() {
        this.fn('_undo', this.type, this.data);
      },
      redo: function() {
        this.fn('_redo', this.type, this.data);
      }
    });
    // // 路径动画入栈事件
    // this.$bus.on('undo_redo_path', this.inStackPath);
    // // 创建路径动画栈
    // this.stackPath = new Undo.Stack();
    // this.editCommandPath = Undo.Command.extend({
    //   constructor: function(type, data, fn) {
    //     this.type = type;
    //     this.data = data;
    //     this.fn = fn;
    //   },
    //   execute: function() {},
    //   undo: function() {
    //     this.fn('_undoPath', this.type, this.data);
    //   },
    //   redo: function() {
    //     this.fn('_redoPath', this.type, this.data);
    //   }
    // });
    // // 改变type,相当于切换栈
    // this.$bus.on('change_undo_type', data => {
    //   this.type = data.type;
    //   // 是否清空路径动画栈
    //   if(data.clearStack) {
    //     this.stackPath.clearStack()
    //   }
    //   this.canUndoRedo();
    // });
  },
  beforeDestroy () {
    this.$bus.off('undo_redo_clear', this.onUndoRedoClear);
  },
  methods: {
    fn(mod, type, data) {
      this[mod](type, data);
      // 发送撤销和恢复的事件
      this.$bus.emit('undoRedoHandle', {
        type: type,
        mod: mod
      });
    },
    inStack(data) {
      // 画布栈入栈
      this.stack.execute(new this.editCommand(data.type, data.data, this.fn));
      this.canUndoRedo();
    },
    undo() {
      this.stack.undo();
      this.canUndoRedo();
    },
    redo() {
      this.stack.redo();
      this.canUndoRedo();
    },
    _undo(type, data) {
      let scene,
          sprite,
          scale,
          mid;
      switch (type) {
        case 'animMatting': 
          const {animSprite,animUrl,animOldUrl,future,current,spriteImg,playImg} = data;
          const handleUrl = this.$handleAssetsUrl(animOldUrl);
          spriteImg.attr('src', handleUrl);
          playImg.attr('src', handleUrl);
          future.attr('src', handleUrl);
          current.attr('src', handleUrl);
          animSprite.option.url = animOldUrl;
        break;
        case 'finishMatting': 
          let {img,spriteOption,url,oldUrl, slidePlay} = data;
          img.attr('src', this.$handleAssetsUrl(oldUrl));
          slidePlay.attr('src', this.$handleAssetsUrl(oldUrl));
          spriteOption.url = oldUrl;
        break;
        case 'addSprite':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          this.TOOL.removeSprite(data.id);
          break;
        case 'removeSprite':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          this.TOOL.addSpriteJson({id: data.scenesId, sprites: [data], scale: data.scale / this.TOOL.scale});
          break;
        case 'updateSprite':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          let option = {};
          switch(data.type) {
            case 'Chart':
              option.style = JSON.parse(data.style);
              option.data = JSON.parse(data.data);
              option.scenesId = data.scenesId;
              option.chartType = data.chartType;
              option.chartOption = Object.assign({}, this.$chartFromJson(option));
              break;
            case 'Text':
              option.text = data.text;
              option.font = data.font;
              option.letterSpacing = data.characterSpacing;
              option.lineHeight = data.lineSpacing;
              option.artStyle = Object.assign({color: data.font.color}, data.artStyle)
              break;
            default:
              option = data.reData;
          }
          this.TOOL.updateSprite(data.id, option, data.scenesId);
          break;
        case 'textSpacing':
          if (this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          this.TOOL.updateSprite(data.id, data.reData, data.scenesId);
          break;
        case 'matrix':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.oldVal.length; i++) {
            sprite = this.TOOL.findSpriteById(data.oldVal[i].id);
            sprite.update({
              width : data.oldVal[i].width * data.scale / this.TOOL.scale,
              height : data.oldVal[i].height * data.scale / this.TOOL.scale,
              positionLeft : data.oldVal[i].positionLeft * data.scale / this.TOOL.scale,
              positionTop : data.oldVal[i].positionTop * data.scale / this.TOOL.scale,
              rotate : data.oldVal[i].rotate
            })
          }
          this.SelectSprites_Msg.length > 1 && this.TOOL.calcMultiSelect('rePaint');
          break;
        case 'swapSprite':
          if(this.SelectScenes_Msg.id !== data.sprite.scenesId) {
            scene = this.TOOL.getScenesIdData(data.sprite.scenesId);
            this.TOOL.selectScenes(scene);
          }
          data.reSprite && this.TOOL.removeSprite(data.reSprite.id);
          if (data.gruop) {
            data.gruop.reduce((sequence, sprite) => {
              return sequence.then(() => {
                return this.TOOL.removeSprite(sprite.id);
              });
            }, Promise.resolve());
          }
          this.TOOL.addSpriteJson({id: data.sprite.scenesId, sprites: [data.sprite], scale: data.sprite.scale / this.TOOL.scale});
          break;
        case 'addVideo':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          this.TOOL.removeVideos();
          if (data.reData.type === 'sprite') {
            this.TOOL.addSpriteJson({
              id: data.scenesId,
              sprites: [data.reData.sprite],
              scale: data.scale / this.TOOL.scale
            });

          }
          if (data.reData.type === 'bg') {
            this.TOOL.selectedScenes.setBackground(data.reData.bg);
          }

          data.data.type === 'bg' && this.TOOL.selectedScenes.setBackground(data.reData.bg);

          data.reData.spriteToRemove && this.TOOL.addSpriteJson({
            id: data.scenesId,
            sprites: [data.reData.spriteToRemove],
            scale: data.scale / this.TOOL.scale
          });
          break;
        case 'addScenes': {
          let changeTime = [0, 0];
          for(let i = 0; i < this.TOOL.sprites.length; i++) {
            if(this.TOOL.sprites[i].id === data.id) {
              changeTime[1] = changeTime[0] + this.TOOL.sprites[i].duration / 1000;
              break;
            }
            changeTime[0] += this.TOOL.sprites[i].duration / 1000;
          }
          this.soundHandle.delScenesSound(changeTime);
          this.$store.commit('subtitle/delScenesSound', changeTime);
          if(this.SelectScenes_Msg.id !== data.id) {
            this.TOOL.removeScenes(data.id);
          }else {
            this.TOOL.removeScenes(data.id).then((data) => {
              if(data){
                let index = data[0].index;
                let nextIndex = index >= this.TOOL.sprites.length ? index - 1 : index;
                for(var i=0; i < this.TOOL.sprites.length; i++){
                  if(this.TOOL.sprites[i].index === nextIndex){
                    if(this.TOOL.selectedScenes.id !== data.id){
                      this.TOOL.selectScenes(this.TOOL.sprites[i]);
                    }
                  };
                };
              }
            });
          }
          break;
        }
        case 'removeScenes': {
          let changeTime = [0, 0];
          for(let i = 0; i < data.zIndex; i++) {
            changeTime[0] += this.TOOL.sprites[i].duration / 1000;
          }
          let addSounds = [];
          if(data.dubbing && data.dubbing.length) {
            let dub = null;
            for(let i = 0; i < data.dubbing.length; i++) {
              dub = data.dubbing[i];
              addSounds.push({
                id: dub.resourceId,
                title: dub.title,
                fileType: dub.fileType,
                url: dub.url,
                timeSlot: [changeTime[0]+dub.timeSlot[0], changeTime[0]+dub.timeSlot[1]],
                cut: [...dub.cut]
              })
            }
          }
          let addSubtitles = [];
          if(data.subtitles && data.subtitles.length) {
            let sub = null;
            for(let i = 0; i < data.subtitles.length; i++) {
              sub = data.subtitles[i];
              addSubtitles.push({
                text: sub.text,
                startTime: changeTime[0] + sub.startTime,
                endTime: changeTime[0] + sub.endTime,
                font: { ...sub.font },
                dropShadow: { ...sub.dropShadow },
                outward: { ...sub.outward }
              })
            }
          }
          this.TOOL.addScenes(data.id).then((scene) => {
            this.TOOL.moveScenesTo(scene.id, data.zIndex);
            this.TOOL.selectScenes(scene);
            scene.fromJson(data, data.scale / this.TOOL.scale, true);
            // 配音逻辑
            changeTime[1] = changeTime[0] + scene.duration / 1000;
            this.soundHandle.addScenesSound(changeTime, addSounds);
            this.$store.commit('subtitle/addScenesSound', { changeTime, subtitles: addSubtitles });
          })
          break;
        }
        case 'copyScenes': {
          let changeTime = [0, 0];
          for(let i = 0; i < this.TOOL.sprites.length; i++) {
            if(this.TOOL.sprites[i].id === data.id) {
              changeTime[1] = changeTime[0] + this.TOOL.sprites[i].duration / 1000;
              break;
            }
            changeTime[0] += this.TOOL.sprites[i].duration / 1000;
          }
          this.soundHandle.delScenesSound(changeTime);
          this.$store.commit('subtitle/delScenesSound', changeTime);
          if(this.SelectScenes_Msg.id !== data.id) {
            this.TOOL.removeScenes(data.id);
          }else {
            this.TOOL.removeScenes(data.id).then((data) => {
              if(data){
                let index = data[0].index;
                let nextIndex = index >= this.TOOL.sprites.length ? index - 1 : index;
                for(var i=0; i < this.TOOL.sprites.length; i++){
                  if(this.TOOL.sprites[i].index === nextIndex){
                    if(this.TOOL.selectedScenes.id !== data.id){
                      this.TOOL.selectScenes(this.TOOL.sprites[i]);
                    }
                  };
                };
              }
            });
          }
          break;
        }
        case 'moveScenesTo': {
          let changeTime = [0, 0, 0, 0];
          let canBreak = -1;
          for(let i = 0; i < this.TOOL.sprites.length; i++) {
            let s = this.TOOL.sprites[i];
            if(s.id === data.id) {
              changeTime[1] += (changeTime[0] + s.duration / 1000);
              canBreak++;
            }
            if(i === data.index) {
              if(data.index > this.SelectScenes_Msg.index) {
                changeTime[2] += s.duration / 1000;
              }
              changeTime[3] = changeTime[2]
              canBreak++;
            }
            if(changeTime[1] === 0) {
              changeTime[0] += s.duration / 1000;
            }
            if(changeTime[3] === 0 && data.index) {
              changeTime[2] += s.duration / 1000;
            }
            if(canBreak > 0) {
              break;
            }
          }
          this.soundHandle.swapScenesSound(changeTime);
          this.$store.commit('subtitle/swapScenesSound', changeTime);
          this.TOOL.moveScenesTo(data.id, data.index);
          break;
        }
        case 'flip':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          sprite = this.TOOL.findSpriteById(data.id);
          sprite.flipStyle();
          break;
        case 'moveSpriteTo':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          this.TOOL.moveSpriteTo(data.id, data.index);
          break;
        case 'ctrlDelete':
        case 'ctrlX':
          if(this.SelectScenes_Msg.id !== data.id) {
            scene = this.TOOL.getScenesIdData(data.id);
            this.TOOL.selectScenes(scene);
          }
          this.TOOL.addSpriteJson({id: data.id, sprites: data.sprites, scale: data.scale / this.TOOL.scale})
          break;
        case 'setBackground':
          scene = this.TOOL.getScenesIdData(data.scenesId);
          this.TOOL.selectScenes(scene);
          this.$store.commit('del_vipSprites', {id : 'BG-'+ data.scenesId});
          if(data.reData.type === 'Image' || data.reData.type === 'Video') {
            this.$bus.emit('judgeItemPayType_vue',{
              type     : 'bg',
              id       : ('BG-'+data.scenesId),
              option   : {
                resourceId  : data.reData.resourceId,      // 背景资源id
                fileType    : data.reData.fileType,// 背景资源type
              },
              opHelper : {
                isSvip : false,
              },
              scenesId :  data.scenesId
            });
          }
          scene.setBackground(data.reData);
          break;
        case 'setSound':
          this.TOOL.setSound(data.reData);
          break;
        case 'setSoundRecord':
          this.TOOL.setSoundRecord(data.reData, data.reParams.mode);
          break;
        case 'setSoundScenes':
          scene = this.TOOL.getScenesIdData(data.scenesId);
          scene.setSound(data.reData);
          break;
        case 'clearGlobalSoundRecord':
          this.TOOL.clearSoundRecord({ undoData: data.reData });
          break;
        case 'toFromJson':
          scene = this.TOOL.getScenesIdData(data.scenesId);
          this.TOOL.selectScenes(scene);
          if(data.dubbingData) {
            let addSounds = [];
            let changeTime = [0, 0, 0];
            let scenes = this.TOOL.sprites;
            for(let i = 0; i < scenes.length; i++) {
              if(scenes[i].id === data.scenesId) {
                changeTime[1] = changeTime[0] + scene.duration / 1000;
                changeTime[2] = changeTime[0] + data.data.duration;
                break;
              }
              changeTime[0] += (scenes[i].duration / 1000);
            }
            if(data.dubbingData.undoDubbing) {
              let dub = null;
              for(let i = 0; i < data.dubbingData.undoDubbing.length; i++) {
                dub = data.dubbingData.undoDubbing[i];
                addSounds.push({
                  id: dub.resourceId,
                  title: dub.title,
                  fileType: dub.fileType,
                  url: dub.url,
                  timeSlot: [changeTime[0]+dub.timeSlot[0], changeTime[0]+dub.timeSlot[1]],
                  cut: [...dub.cut]
                })
              }
            }
            let addSubtitles = [];
            if (data.subtitleData.undoSubtitles) {
              let sub = null;
              for (let i = 0; i < data.subtitleData.undoSubtitles.length; i++) {
                sub = data.subtitleData.undoSubtitles[i];
                addSubtitles.push({
                  text: sub.text,
                  startTime: changeTime[0] + sub.startTime,
                  endTime: changeTime[0] + sub.endTime,
                  font: { ...sub.font },
                  dropShadow: { ...sub.dropShadow },
                  outward: { ...sub.outward }
                })
              }
            }
            this.soundHandle.updateScenesSound(changeTime, addSounds);
            this.$store.commit('subtitle/updateScenesSound', { changeTime, subtitles: addSubtitles });
          }
          scene.sprites.length && scene._clearSprites();
          let jsonData = Object.assign({scale: data.scale / this.TOOL.scale}, data.data);
          this.TOOL.addSpriteJson(jsonData);
          this.$bus.emit('timeline_update_totaltime',{data: 'scenes'});
          break;
        case 'changeTotalTime':
          scene = this.TOOL.getScenesIdData(data.scenesId);
          let changeTime = [0, -data.change, this.TOOL.getDuration()]
          for (let i = 0; i < this.TOOL.sprites.length; i++) {
            if(this.TOOL.sprites[i].id === data.scenesId) {
              changeTime[0] += this.TOOL.sprites[i].duration / 1000;
              break;
            }
          }
          this.soundHandle.changeScenesTime(...changeTime)
          this.$store.commit('subtitle/changeScenesTime', changeTime);
          scene.setDuration(scene.getDuration() - data.change*1000)
          data.changeData.sprites.forEach(info => {
            sprite = this.TOOL.findSpriteById(info.id);
            sprite.updateEffect(info.reData)
          })
          data.changeData.cameras.forEach(info => {
            if(info.way === 'update') {
              scene.camera.updateCamera(info.index, {animations: info.reData})
            } else if(info.way === 'delete') {
              scene.camera.addCamera(info.reData, info.index)
            }
          })
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            this.TOOL.selectScenes(scene)
          }
          break;
        case 'updateScenesEffect':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
          } else {
            scene = this.SelectScenes_Msg;
          }
          scene.updateEffect(data.reData);
          break;
        case 'setVideoBgDuration':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene).then((scene) => {
              scene.setVideoBgDuration(data.reData);
            });
          }else {
            this.SelectScenes_Msg.setVideoBgDuration(data.reData);
          }
          break;
        case 'setBackgroundFilter':
          if (this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene).then((scene) => {
              scene.setBackgroundFilter(data.reData);
            });
          } else {
            this.SelectScenes_Msg.setBackgroundFilter(data.reData);
          }
          break;
        case 'setBackgroundBlur':
          if (this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene).then((scene) => {
              scene.setBackgroundBlur(data.reData);
            });
          } else {
            this.SelectScenes_Msg.setBackgroundBlur(data.reData);
          }
          break;
        case 'setBackgroundOpacity':
          if (this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene).then((scene) => {
              scene.setBackgroundOpacity(data.reData);
            });
          } else {
            this.SelectScenes_Msg.setBackgroundOpacity(data.reData);
          }
          break;
        case 'setBackgroundZoom':
          if (this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene).then((scene) => {
              scene.setBgZoom(data.reData.zoomActive, data.reData.zoomOptions);
            });
          } else {
            this.SelectScenes_Msg.setBgZoom(data.reData.zoomActive, data.reData.zoomOptions);
          }
          break;
        case 'updateSpriteEffect':
          this.TOOL.selectSprite();
          ({scene, sprite} = this.select(data.scenesId, data.id));
          // sprite = this.TOOL.findSpriteById(data.id);
          sprite.updateEffect(data.reData)
          break;
        case 'updateHandle':
          sprite = this.TOOL.findSpriteById(data.id);
          sprite.update(data.reData)
          break;
        case 'setLoop':
          sprite = this.TOOL.findSpriteById(data.id);
          sprite.setLoop(data.reData.val);
          break;
        case 'cropImage':
          sprite = this.TOOL.findSpriteById(data.id);
          if (data.data.cropType === 'free') {
            sprite.setCropBoxData(data.data.cropBoxData, { rect: data.data.rect, cropType: data.data.cropType });
          } else if (data.data.cropType === 'svg') {
            sprite.setSvgCrop(data.data.cropBoxData, data.data.url);
          } else {
            sprite.cancelCrop(data.data.cancelCropData);
          }
          break;
        case 'framePicMatrix':
          sprite = this.TOOL.findSpriteById(data.id);
          sprite.setPicMatrix(data.reData);
          break;
        case 'frameLoadPic':
          sprite = this.TOOL.findSpriteById(data.id);
          sprite.loadPic(data.reData);
          break;
        case 'setVideoSpriteVolume':
          sprite = this.TOOL.findSpriteById(data.id);
          sprite.setVolume(data.reData.volume);
          break;
        case 'videoSprite.setLoop':
          sprite = this.TOOL.findSpriteById(data.id);
          sprite.setLoop(data.reData.loop);
          break;
        case 'videoSprite.setRepeatTimes':
          sprite = this.TOOL.findSpriteById(data.id);
          sprite.setRepeatTimes(data.reData.repeatTimes);
          break;
        case 'videoSprite.setCutDuration':
          sprite = this.TOOL.findSpriteById(data.id);
          sprite.setCutDuration(data.reData);
          break;
        case 'setBgLaying':
          if (this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene).then((scene) => {
              scene.setBgLaying(data.reData.layingType);
            });
          } else {
            this.SelectScenes_Msg.setBgLaying(data.reData.layingType);
          }
          break;
        case 'artSetting':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          sprite = this.TOOL.findSpriteById(data.id);
          if(data.data.effectCode) sprite.updateEffect({code: data.data.effectCode})
          sprite.artSetting(data.reData);
          break;
        case 'pasteFromClipboard':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          data.sprites.forEach( s => {
            this.TOOL.removeSprite(s.id);
          })
          break;
        case 'path_dragPathUp':
          ({scene, sprite} = this.select(data.scenesId, data.spriteId))
          scale = data.scale/this.TOOL.scale;
          mid = Object.assign({}, data.reData.spriteInfo)
          mid.width *= scale;
          mid.height *= scale;
          mid.positionTop *= scale;
          mid.positionLeft *= scale;
          sprite.update(mid);
          mid = $.extend(true, {}, data.reData.pathAnim)
          mid.target.h *= scale;
          mid.target.w *= scale;
          mid.target.x *= scale;
          mid.target.y *= scale;
          mid.info.width *= scale;
          mid.info.height *= scale;
          mid.info.top *= scale;
          mid.info.left *= scale;
          mid.info.path && this._scaleArr(mid.info.path, scale);
          mid.info.points && this._scaleArrTwo(mid.info.points, scale);
          sprite.updateEffect({
            pathAnim: mid
          });
          break;
        case 'path_pathType':
          ({scene, sprite} = this.select(data.scenesId, data.spriteId))
          scale = data.scale/this.TOOL.scale;
          mid = $.extend(true, {}, data.reData)
          mid.target.h *= scale;
          mid.target.w *= scale;
          mid.target.x *= scale;
          mid.target.y *= scale;
          mid.info.width *= scale;
          mid.info.height *= scale;
          mid.info.top *= scale;
          mid.info.left *= scale;
          mid.info.path && this._scaleArr(mid.info.path, scale);
          mid.info.points && this._scaleArrTwo(mid.info.points, scale);
          sprite.updateEffect({
            pathAnim: mid
          });
          data.action === 'paint' && this.$bus.emit('set_path_anim', {action: 'close'});
          break;
        case 'path_changeSpeed':
          ({scene, sprite} = this.select(data.scenesId, data.spriteId))
          sprite.updateEffect({
            pathAnim: {
              easing: data.reData
            }
          });
          break;
        case 'path_setLoop':
          ({scene, sprite} = this.select(data.scenesId, data.spriteId))
          sprite.updateEffect({
            pathAnim: {
              loop: !sprite.effect.pathAnim.loop
            }
          });
          break;
        case 'path_changeTime':
          ({scene, sprite} = this.select(data.scenesId, data.spriteId))
          sprite.updateEffect({
            pathAnim: data.reData
          });
          break;
        case 'path_paintPathZ':
          this.$bus.emit('set_path_anim', {action: 'undo', type: 'undo_paintZ'});
          break;
        case 'path_paintDb':
          this.$bus.emit('set_path_anim', {action: 'undo', type: 'undo_paintDb'});
          break;
        case 'path_editMove':
          scale = data.scale / this.TOOL.scale;
          mid = [].concat(data.reData);
          this._scaleArr(mid, scale)
          this.$bus.emit('set_path_anim', {action: 'undo', type: 'editMove', data: mid, pIndex: data.pIndex});
          break;
        case 'path_freePathType':
          this.$bus.emit('set_path_anim', {action: 'undo', type: 'freePathType', data: data.reData});
          break;
        case 'path_savePath':
          ({scene, sprite} = this.select(data.scenesId, data.spriteId));
          mid = $.extend(true, {}, data.reData)
          scale = data.scale / this.TOOL.scale
          mid.target.h *= scale;
          mid.target.w *= scale;
          mid.target.x *= scale;
          mid.target.y *= scale;
          mid.info.width *= scale;
          mid.info.height *= scale;
          mid.info.top *= scale;
          mid.info.left *= scale;
          mid.info.path && this._scaleArr(mid.info.path, scale);
          mid.info.points && this._scaleArrTwo(mid.info.points, scale);
          sprite.updateEffect({
            pathAnim: mid
          });
          mid = $.extend(true, [], data.data.info.points)
          this._scaleArrTwo(mid, scale)
          this.$bus.emit('set_path_anim', {action: 'edit', data: mid})
          break;
        case 'path_dbToEdit':
          this.$bus.emit('set_path_anim', {action: 'close'})
          break;
        case 'path_delPoint':
          mid = [].concat(data.reData);
          scale = data.scale / this.TOOL.scale
          this._scaleArr(mid, scale);
          this.$bus.emit('set_path_anim', {action: 'undo', type: 'delPoint', data: mid, pIndex: data.pIndex})
          break;
        case 'path_exitEdit':
          scale = data.scale/this.TOOL.scale;
          mid = $.extend(true, [], data.reData);
          this._scaleArrTwo(mid, scale)
          this.select(data.scenesId, data.spriteId);
          this.$bus.emit('set_path_anim', {action: 'edit', data: mid})
          break;
        case 'camera_matrix':
          scene = this.TOOL.getScenesIdData(data.scenesId);
          scale = data.scale/this.TOOL.scale;
          scene.camera.updateCamera(data.cameraIndex, {
            matrix: {
              h: data.reData.h * scale,
              w: data.reData.w * scale,
              x: data.reData.x * scale,
              y: data.reData.y * scale,
            }
          })
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            this.TOOL.selectScenes(scene)
            this.$store.commit('toggle_cameras', scene.camera.cameras);
          } else {
            this.TOOL.selectSprite();
          }
          this.$store.commit('toggle_lensIndex', data.cameraIndex);
          this.$store.commit('toggle_lensEditState', true);
          break;
        case 'camera_add':
          scene = this.TOOL.getScenesIdData(data.scenesId);
          scene.camera.delCamera(data.cameraIndex)
          this.$store.commit('toggle_lensIndex', -1);
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            this.TOOL.selectScenes(scene).then(() => {
              this.$store.commit('toggle_lensEditState', true);
            });
          } else {
            this.TOOL.selectSprite();
            this.$store.commit('toggle_lensEditState', true);
          }
          break;
        case 'camera_delete':
          scene = this.TOOL.getScenesIdData(data.scenesId);
          mid = $.extend(true, {}, data.reData)
          scale = data.scale/this.TOOL.scale;
          mid.matrix = {
            h: data.reData.matrix.h * scale,
            w: data.reData.matrix.w * scale,
            x: data.reData.matrix.x * scale,
            y: data.reData.matrix.y * scale,
          }
          scene.camera.addCamera(mid, data.cameraIndex)
          this.$store.commit('toggle_lensIndex', data.cameraIndex);
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            this.TOOL.selectScenes(scene).then(() => {
              this.$store.commit('toggle_lensEditState', true);
            });
          } else {
            this.TOOL.selectSprite();
            this.$store.commit('toggle_lensEditState', true);
          }
          break;
        case 'camera_changeTime':
          scene = this.TOOL.getScenesIdData(data.scenesId);
          scene.camera.updateCamera(data.cameraIndex, {animations: data.reData})
          this.$store.commit('toggle_lensIndex', data.cameraIndex);
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            this.TOOL.selectScenes(scene).then(() => {
              this.$store.commit('toggle_lensEditState', true);
            });
          } else {
            this.TOOL.selectSprite();
            this.$store.commit('toggle_lensEditState', true);
          }
          break;
        case 'timeline_drag':
          scene = this.TOOL.getScenesIdData(data.scenesId);
          data.reData.forEach(info => {
            sprite = this.TOOL.findSpriteById(info.id);
            sprite.updateEffect(info.data)
          })
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            this.TOOL.selectScenes(scene)
          }
          break;
        case 'editor_resize':
          if(data.type === 0) {
            this.TOOL.setOptimized(2);
          }else {
            this.TOOL.setOptimized(0);
          }
          scale = data.scale/this.TOOL.scale;
          data.scenes.forEach(s => {
            scene = this.TOOL.getScenesIdData(s.id);
            scene.camera.fromJson($.extend(true, [], s.cameras), scale)
          })
          break;
        case 'formatBrush':
          this.TOOL.selectSprite();
          ({scene, sprite} = this.select(data.scenesId, data.spriteId));
          if(data.reData.text) {
            sprite.artSetting({artType: data.reData.text.artType})
            sprite.setversionAnyway(data.reData.text.versionAnyway)
            sprite.updateSprite(data.reData.text.option)
          }
          if(data.reData.strokeSvg) {
            sprite.updateSprite(data.reData.strokeSvg).then(() => {
              sprite.update(data.reData.outward);
            })
          }else {
            sprite.update(data.reData.outward);
          }
          if(data.reData.numberOfLoops) {
            if(sprite.type === 'Video') {
              sprite.setRepeatTimes(data.reData.numberOfLoops);
            }else {
              sprite.setLoop(data.reData.numberOfLoops)
            }
            sprite.setLoop(data.reData.isLoop)
          }

          sprite.setBorder(data.reData.border);
          sprite.setShadow(data.reData.boxShadow);
          sprite.setShadow(data.reData.dropShadow, 'dropShadow');
          sprite.setBgColor(data.reData.bgColor);
          sprite.setFilter(data.reData.filter);
          sprite.updateEffect(data.reData.effect);
          break;
        case 'bgColor':
          ({scene, sprite} = this.select(data.scenesId, data.spriteId));
          sprite.setBgColor(data.reData);
          break;
        case 'changeBorder':
          ({scene, sprite} = this.select(data.scenesId, data.spriteId));
          sprite.setBorder(data.reData);
          break;
        case 'setShadow':
          ({scene, sprite} = this.select(data.scenesId, data.spriteId));
          sprite.setShadow(data.reData.data, data.reData.type);
          break;
        case 'richEdit':
          ({scene, sprite} = this.select(data.scenesId, data.spriteId));
          sprite.edited(data.reData);
          break;
        case 'opacitys':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.reData.length; i++) {
            sprite = this.TOOL.findSpriteById(data.reData[i].id);
            sprite._opacity = null;
            sprite.opacity = data.reData[i].opacity;
            sprite.changeStyle({ sync: true });
          }
          break;
        case 'volumes':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.reData.length; i++) {
            sprite = this.TOOL.findSpriteById(data.reData[i].id);
            if(sprite.type === 'Video') {
              sprite.setVolume(data.reData[i].volume)
            } else {
              sprite.setSound({
                volume  : data.reData[i].volume,
              })
            }
          }
          break;
        case 'setLoops':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.reData.length; i++) {
            sprite = this.TOOL.findSpriteById(data.reData[i].id);
            if(sprite.type === 'Video') {
              if(typeof (data.reData[i].val) === 'boolean') {
                sprite.setLoop(data.reData[i].val)
              } else {
                sprite.setRepeatTimes(data.reData[i].val)
              }
            } else {
              sprite.setLoop(data.reData[i].val)
            }
          }
          break;
        case 'textSettings':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.reData.length; i++) {
            sprite = this.TOOL.findSpriteById(data.reData[i].id);
            if(sprite.versionAnyway !== data.reData[i].versionAnyway) {
              sprite.setversionAnyway(data.reData[i].versionAnyway)
            }
            sprite.updateSprite(data.reData[i]);
          }
          break;
        case 'artSettings':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.reData.length; i++) {
            sprite = this.TOOL.findSpriteById(data.reData[i].id);
            if(data.reData[i].effectCode) sprite.updateEffect({code: data.reData[i].effectCode})
            sprite.artSetting(data.reData[i]);
          }
          break;
        case 'bgColors':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.reData.length; i++) {
            sprite = this.TOOL.findSpriteById(data.reData[i].id);
            sprite.setBgColor(data.reData[i].hex);
          }
          break;
        case 'setBorders':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.reData.length; i++) {
            sprite = this.TOOL.findSpriteById(data.reData[i].id);
            sprite.setBorder(data.reData[i].border)
          }
          break;
        case 'setShadows':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.reData.length; i++) {
            sprite = this.TOOL.findSpriteById(data.reData[i].id);
            sprite.setShadow(data.reData[i].shadow, data.reData[i].type);
          }
          break;
        case 'setFilters':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.reData.length; i++) {
            sprite = this.TOOL.findSpriteById(data.reData[i].id);
            sprite.setFilter(data.reData[i].filter);
          }
          break;
        case 'updateEffects':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.reData.length; i++) {
            sprite = this.TOOL.findSpriteById(data.reData[i].id);
            sprite.updateEffect(data.reData[i].data)
          }
          break;
        case 'layerSetting':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.reData.length; i++) {
            sprite = this.TOOL.findSpriteById(data.reData[i].id);
            sprite.zIndex = data.reData[i].index;
            sprite.setIndex(data.reData[i].index);
          }
          this.SelectScenes_Msg.sprites.sort(function (a, b) {
            return a.zIndex - b.zIndex;
          });
          break;
        case 'strokeWidths':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.reData.length; i++) {
            sprite = this.TOOL.findSpriteById(data.reData[i].id);
            sprite.updateSprite({strokeWidth: data.reData[i].val})
          }
          break;
        case 'strokeColors':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.reData.length; i++) {
            sprite = this.TOOL.findSpriteById(data.reData[i].id);
            sprite.updateSprite({stroke: data.reData[i].val})
          }
          break;
        case 'fillColors':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.reData.length; i++) {
            sprite = this.TOOL.findSpriteById(data.reData[i].id);
            sprite.updateSprite({fill: data.reData[i].val})
          }
          break;
        default:
          break;
      }
    },
    _redo(type, data) {
      let scene,
          sprite,
          mid,
          scale;
      switch (type) {
        case 'animMatting': 
        const {animSprite,animUrl,animOldUrl,future,current,spriteImg,playImg} = data;
        const handleUrl = this.$handleAssetsUrl(animUrl);
        spriteImg.attr('src', handleUrl);
        playImg.attr('src', handleUrl);
        future.attr('src', handleUrl);
        current.attr('src', handleUrl);
        animSprite.option.url = animUrl;
        break;
        case 'finishMatting': 
          let {img,spriteOption,url,oldUrl,slidePlay} = data;
          img.attr('src', this.$handleAssetsUrl(url));
          slidePlay.attr('src', this.$handleAssetsUrl(url));
          spriteOption.url = url;
        break;
        case 'addSprite':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          this.TOOL.addSpriteJson({id: data.scenesId, sprites: [data], scale: data.scale / this.TOOL.scale});
          break;
        case 'removeSprite':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          this.TOOL.removeSprite(data.id);
          break;
        case 'updateSprite':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          this.TOOL.updateSprite(data.id, data.data, data.scenesId);
          break;
        case 'textSpacing':
          if (this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          this.TOOL.updateSprite(data.id, data.data, data.scenesId);
          break;
        case 'matrix':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.val.length; i++) {
            sprite = this.TOOL.findSpriteById(data.val[i].id);
            sprite.update({
              width : data.val[i].width * data.scale / this.TOOL.scale,
              height : data.val[i].height * data.scale / this.TOOL.scale,
              positionLeft : data.val[i].positionLeft * data.scale / this.TOOL.scale,
              positionTop : data.val[i].positionTop * data.scale / this.TOOL.scale,
              rotate : data.val[i].rotate
            })
          }
          this.SelectSprites_Msg.length > 1 && this.TOOL.calcMultiSelect('rePaint');
          break;
        case 'swapSprite':
          if(this.SelectScenes_Msg.id !== data.reSprite.scenesId) {
            scene = this.TOOL.getScenesIdData(data.reSprite.scenesId);
            this.TOOL.selectScenes(scene);
          }
          this.TOOL.removeSprite(data.sprite.id);
          if (data.callback) {
            data.callback();
          } else {
            this.TOOL.addSpriteJson({id:data.reSprite.scenesId, sprites: [data.reSprite], scale: data.reSprite.scale / this.TOOL.scale});
          }
          break;
        case 'addVideo':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          this.TOOL.removeVideos();
          if (data.data.type === 'sprite') {
            this.TOOL.addSpriteJson({
              id: data.scenesId,
              sprites: [data.data.sprite],
              scale: data.scale / this.TOOL.scale
            });
          }
          if (data.data.type === 'bg') {
            this.TOOL.selectedScenes.setBackground(data.data.bg)
              .then(() => {
                eve('addVideo.bg', null, this.TOOL.selectedScenes);
              })
          }
          if (data.reData.spriteToRemove) {
            this.TOOL.removeSprite(data.reData.spriteToRemove.id);
          }
          break;
        case 'addScenes': {
          let changeTime = [0, 0];
          for(let i = 0; i < data.zIndex; i++) {
            changeTime[0] += this.TOOL.sprites[i].duration / 1000;
          }
          this.TOOL.addScenes(data.id).then((scene) => {
            this.TOOL.moveScenesTo(scene.id, data.zIndex);
            this.TOOL.selectScenes(scene);
            scene.fromJson(data);
            // 配音逻辑
            changeTime[1] = changeTime[0] + scene.duration / 1000;
            this.soundHandle.addScenesSound(changeTime, []);
            this.$store.commit('subtitle/addScenesSound', { changeTime, subtitles: [] });
          });
          break;
        }
        case 'removeScenes': {
          let changeTime = [0, 0];
          for(let i = 0; i < this.TOOL.sprites.length; i++) {
            if(this.TOOL.sprites[i].id === data.id) {
              changeTime[1] = changeTime[0] + this.TOOL.sprites[i].duration / 1000;
              break;
            }
            changeTime[0] += this.TOOL.sprites[i].duration / 1000;
          }
          this.soundHandle.delScenesSound(changeTime);
          this.$store.commit('subtitle/delScenesSound', changeTime);
          if(this.SelectScenes_Msg.id !== data.id) {
            this.TOOL.removeScenes(data.id);
          }else {
            this.TOOL.removeScenes(data.id).then((data) => {
              if(data){
                let index = data[0].index;
                let nextIndex = index >= this.TOOL.sprites.length ? index - 1 : index;
                for(var i=0; i < this.TOOL.sprites.length; i++){
                  if(this.TOOL.sprites[i].index === nextIndex){
                    if(this.TOOL.selectedScenes.id !== data.id){
                      this.TOOL.selectScenes(this.TOOL.sprites[i]);
                    }
                  };
                };
              }
            });
          }
          break;
        }
        case 'copyScenes': {
          let changeTime = [0, 0];
          for(let i = 0; i < this.TOOL.sprites.length; i++) {
            changeTime[0] += this.TOOL.sprites[i].duration / 1000;
          }
          let addSounds = [];
          if(data.dubbing && data.dubbing.length) {
            let dub = null;
            for(let i = 0; i < data.dubbing.length; i++) {
              dub = data.dubbing[i];
              addSounds.push({
                id: dub.resourceId,
                title: dub.title,
                fileType: dub.fileType,
                url: dub.url,
                timeSlot: [changeTime[0]+dub.timeSlot[0], changeTime[0]+dub.timeSlot[1]],
                cut: [...dub.cut]
              })
            }
          }
          let addSubtitles = [];
          if(data.subtitles && data.subtitles.length) {
            let sub = null;
            for(let i = 0; i < data.subtitles.length; i++) {
              sub = data.subtitles[i];
              addSubtitles.push({
                text: sub.text,
                startTime: changeTime[0] + sub.startTime,
                endTime: changeTime[0] + sub.endTime,
                font: { ...sub.font },
                dropShadow: { ...sub.dropShadow },
                outward: { ...sub.outward }
              })
            }
          }
          this.TOOL.addScenes(data.id).then((scene) => {
            this.TOOL.moveScenesTo(scene.id, data.zIndex);
            this.TOOL.selectScenes(scene);
            scene.fromJson(data, data.scale / this.TOOL.scale, true);
            // 配音逻辑
            changeTime[1] = changeTime[0] + scene.duration / 1000;
            this.soundHandle.addScenesSound(changeTime, addSounds);
            this.$store.commit('subtitle/addScenesSound', { changeTime, subtitles: addSubtitles });
          });
          break;
        }
        case 'moveScenesTo': {
          let changeTime = [0, 0, 0, 0];
          let canBreak = -1;
          for(let i = 0; i < this.TOOL.sprites.length; i++) {
            let s = this.TOOL.sprites[i];
            if(s.id === data.id) {
              changeTime[1] += (changeTime[0] + s.duration / 1000);
              canBreak++;
            }
            if(i === data.reIndex) {
              if(data.reIndex > this.SelectScenes_Msg.index) {
                changeTime[2] += s.duration / 1000;
              }
              changeTime[3] = changeTime[2]
              canBreak++;
            }
            if(changeTime[1] === 0) {
              changeTime[0] += s.duration / 1000;
            }
            if(changeTime[3] === 0 && data.reIndex) {
              changeTime[2] += s.duration / 1000;
            }
            if(canBreak > 0) {
              break;
            }
          }
          this.soundHandle.swapScenesSound(changeTime);
          this.$store.commit('subtitle/swapScenesSound', changeTime);
          this.TOOL.moveScenesTo(data.id, data.reIndex);
          break;
        }
        case 'flip':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          sprite = this.TOOL.findSpriteById(data.id);
          sprite.flipStyle();
          break;
        case 'moveSpriteTo':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          this.TOOL.moveSpriteTo(data.id, data.reIndex);
          break;
        case 'ctrlDelete':
        case 'ctrlX':
          if(this.SelectScenes_Msg.id !== data.id) {
            scene = this.TOOL.getScenesIdData(data.id);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.sprites.length; i++){
            this.TOOL.removeSprite(data.sprites[i].id);
          }
          this.TOOL.selectSprite();
          break;
        case 'setBackground':
          scene = this.TOOL.getScenesIdData(data.scenesId);
          this.TOOL.selectScenes(scene);
          this.$store.commit('del_vipSprites', {id : 'BG-'+ data.scenesId});
          if(data.data.type === 'Image' || data.data.type === 'Video') {
            this.$bus.emit('judgeItemPayType_vue',{
              type     : 'bg',
              id       : ('BG-'+data.scenesId),
              option   : {
                resourceId  : data.data.resourceId,      // 背景资源id
                fileType    : data.data.fileType,// 背景资源type
              },
              opHelper : {
                isSvip : false,
              },
              scenesId :  data.scenesId
            });
          }
          scene.setBackground(data.data);
          break;
        case 'setSound':
          this.TOOL.setSound(data.data);
          break;
        case 'setSoundRecord':
          this.TOOL.setSoundRecord(data.data, data.params.mode);
          break;
        case 'setSoundScenes':
          scene = this.TOOL.getScenesIdData(data.scenesId);
          scene.setSound(data.data);
          break;
        case 'clearGlobalSoundRecord':
          this.TOOL.clearSoundRecord();
          break;
        case 'toFromJson':
          scene = this.TOOL.getScenesIdData(data.scenesId);
          this.TOOL.selectScenes(scene);
          if(data.dubbingData) {
            let addSounds = [];
            let changeTime = [0, 0, 0];
            let scenes = this.TOOL.sprites;
            for(let i = 0; i < scenes.length; i++) {
              if(scenes[i].id === data.scenesId) {
                changeTime[1] = changeTime[0] + scene.duration / 1000;
                changeTime[2] = changeTime[0] + data.reData.duration;
                break;
              }
              changeTime[0] += (scenes[i].duration / 1000);
            }
            if(data.dubbingData.dubbing) {
              let dub = null;
              for(let i = 0; i < data.dubbingData.dubbing.length; i++) {
                dub = data.dubbingData.dubbing[i];
                addSounds.push({
                  id: dub.resourceId,
                  title: dub.title,
                  fileType: dub.fileType,
                  url: dub.url,
                  timeSlot: [...dub.timeSlot],
                  cut: [...dub.cut]
                })
              }
            }
            let addSubtitles = [];
            if (data.subtitleData.subtitles) {
              let sub = null;
              for (let i = 0; i < data.subtitleData.subtitles.length; i++) {
                sub = data.subtitleData.subtitles[i];
                addSubtitles.push({
                  text: sub.text,
                  startTime: sub.startTime,
                  endTime: sub.endTime,
                  font: { ...sub.font },
                  dropShadow: { ...sub.dropShadow },
                  outward: { ...sub.outward }
                })
              }
            }
            this.soundHandle.updateScenesSound(changeTime, addSounds);
            this.$store.commit('subtitle/updateScenesSound', { changeTime, subtitles: addSubtitles });
          }
          scene.sprites.length && scene._clearSprites();
          let jsonData = Object.assign({scale: data.scale / this.TOOL.scale}, data.reData);
          this.TOOL.addSpriteJson(jsonData);
          this.$bus.emit('timeline_update_totaltime',{data: 'scenes'});
          break;
        case 'changeTotalTime':
          scene = this.TOOL.getScenesIdData(data.scenesId);
          let changeTime = [0, data.change, this.TOOL.getDuration()]
          for (let i = 0; i < this.TOOL.sprites.length; i++) {
            if(this.TOOL.sprites[i].id === data.scenesId) {
              changeTime[0] += this.TOOL.sprites[i].duration / 1000;
              break;
            }
          }
          this.soundHandle.changeScenesTime(...changeTime)
          this.$store.commit('subtitle/changeScenesTime', changeTime);
          scene.setDuration(scene.getDuration() + data.change*1000)
          data.changeData.sprites.forEach(info => {
            sprite = this.TOOL.findSpriteById(info.id);
            sprite.updateEffect(info.data)
          })
          data.changeData.cameras.forEach(info => {
            if(info.way === 'update') {
              scene.camera.updateCamera(info.index, {animations: info.data})
            } else if(info.way === 'delete') {
              scene.camera.delCamera(info.index)
            }
          })
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            this.TOOL.selectScenes(scene)
          }
          break;
        case 'updateScenesEffect':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
          } else {
            scene = this.SelectScenes_Msg;
          }
          scene.updateEffect(data.data);
          break;
        case 'setVideoBgDuration':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene).then((scene) => {
              scene.setVideoBgDuration(data.data);
            });
          }else {
            this.SelectScenes_Msg.setVideoBgDuration(data.data);
          }
          break;
        case 'setBackgroundFilter':
          if (this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene).then((scene) => {
              scene.setBackgroundFilter(data.data);
            });
          } else {
            this.SelectScenes_Msg.setBackgroundFilter(data.data);
          }
          break;
        case 'setBackgroundBlur':
          if (this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene).then((scene) => {
              scene.setBackgroundBlur(data.data);
            });
          } else {
            this.SelectScenes_Msg.setBackgroundBlur(data.data);
          }
          break;
        case 'setBackgroundOpacity':
          if (this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene).then((scene) => {
              scene.setBackgroundOpacity(data.data, true, false);
            });
          } else {
            this.SelectScenes_Msg.setBackgroundOpacity(data.data, true, false);
          }
          break;
        case 'setBackgroundZoom':
          if (this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene).then((scene) => {
              scene.setBgZoom(data.data.zoomActive, data.data.zoomOptions);
            });
          } else {
            this.SelectScenes_Msg.setBgZoom(data.data.zoomActive, data.data.zoomOptions);
          }
          break;
        case 'updateSpriteEffect':
          this.TOOL.selectSprite();
          ({scene, sprite} = this.select(data.scenesId, data.id));
          // sprite = this.TOOL.findSpriteById(data.id);
          sprite.updateEffect(data.data);
          break;
        case 'updateHandle':
          sprite = this.TOOL.findSpriteById(data.id);
          sprite.update(data.data);
          break;
        case 'setLoop':
          sprite = this.TOOL.findSpriteById(data.id);
          sprite.setLoop(data.data.val);
          break;
        case 'cropImage':
          sprite = this.TOOL.findSpriteById(data.id);
          if (data.reData.cropType === 'free') {
            sprite.setCropBoxData(data.reData.cropBoxData, { rect: data.reData.rect, cropType: data.reData.cropType })
          } else if (data.reData.cropType === 'svg') {
            sprite.setSvgCrop(data.reData.cropBoxData, data.reData.url)
          } else {
            sprite.cancelCrop(data.reData.cancelCropData);
          }
          break;
        case 'framePicMatrix':
          sprite = this.TOOL.findSpriteById(data.id);
          sprite.setPicMatrix(data.data);
          break;
        case 'frameLoadPic':
          sprite = this.TOOL.findSpriteById(data.id);
          sprite.loadPic(data.data);
          break;
        case 'setVideoSpriteVolume':
          sprite = this.TOOL.findSpriteById(data.id);
          sprite.setVolume(data.data.volume);
          break;
        case 'videoSprite.setLoop':
          sprite = this.TOOL.findSpriteById(data.id);
          sprite.setLoop(data.data.loop);
          break;
        case 'videoSprite.setRepeatTimes':
          sprite = this.TOOL.findSpriteById(data.id);
          sprite.setRepeatTimes(data.data.repeatTimes);
          break;
        case 'videoSprite.setCutDuration':
          sprite = this.TOOL.findSpriteById(data.id);
          sprite.setCutDuration(data.data);
          break;
        case 'setBgLaying':
          if (this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene).then((scene) => {
              scene.setBgLaying(data.data.layingType);
            });
          } else {
            this.SelectScenes_Msg.setBgLaying(data.data.layingType);
          }
          break;
        case 'artSetting':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          sprite = this.TOOL.findSpriteById(data.id);
          if(data.data.effectCode) sprite.updateEffect({code: 'FadeIn'})
          sprite.artSetting(data.data);
          break;
        case 'pasteFromClipboard':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          this.TOOL.addSpriteJson({id: data.scenesId, sprites: data.sprites, scale: data.scale / this.TOOL.scale});
          break;
        case 'path_dragPathUp':
          ({scene, sprite} = this.select(data.scenesId, data.spriteId))
          scale = data.scale/this.TOOL.scale;
          mid = Object.assign({}, data.data.spriteInfo)
          mid.width *= scale;
          mid.height *= scale;
          mid.positionTop *= scale;
          mid.positionLeft *= scale;
          sprite.update(mid);
          mid = $.extend(true, {}, data.data.pathAnim)
          mid.target.h *= scale;
          mid.target.w *= scale;
          mid.target.x *= scale;
          mid.target.y *= scale;
          mid.info.width *= scale;
          mid.info.height *= scale;
          mid.info.top *= scale;
          mid.info.left *= scale;
          mid.info.path && this._scaleArr(mid.info.path, scale);
          mid.info.points && this._scaleArrTwo(mid.info.points, scale);
          sprite.updateEffect({
            pathAnim: mid
          });
          break;
        case 'path_pathType':
          ({scene, sprite} = this.select(data.scenesId, data.spriteId))
          scale = data.scale/this.TOOL.scale;
          mid = $.extend(true, {}, data.data)
          if(data.action === 'paint') {
            sprite.update({})
          } else {
            mid.target.h *= scale;
            mid.target.w *= scale;
            mid.target.x *= scale;
            mid.target.y *= scale;
            mid.info.width *= scale;
            mid.info.height *= scale;
            mid.info.path && this._scaleArr(mid.info.path, scale);
            mid.info.points && this._scaleArrTwo(mid.info.points, scale);
          }
          this.$bus.emit('set_path_anim', {action: data.action, pathAnim: mid});
          break;
        case 'path_changeSpeed':
          ({scene, sprite} = this.select(data.scenesId, data.spriteId))
          sprite.updateEffect({
            pathAnim: {
              easing: data.data
            }
          });
          break;
        case 'path_setLoop':
          ({scene, sprite} = this.select(data.scenesId, data.spriteId))
          sprite.updateEffect({
            pathAnim: {
              loop: !sprite.effect.pathAnim.loop
            }
          });
          break;
        case 'path_changeTime':
          ({scene, sprite} = this.select(data.scenesId, data.spriteId))
          sprite.updateEffect({
            pathAnim: data.data
          });
          break;
        case 'path_paintPathZ':
          this.$bus.emit('set_path_anim', {action: 'undo', type: 'redo_paintZ'});
          break;
        case 'path_paintDb':
          scale = data.scale/this.TOOL.scale;
          mid = $.extend(true, [], data.data);
          this._scaleArrTwo(mid, scale);
          this.$bus.emit('set_path_anim', {action: 'undo', type: 'redo_paintDb', data: mid});
          break;
        case 'path_editMove':
          scale = data.scale / this.TOOL.scale;
          mid = [].concat(data.data);
          this._scaleArr(mid, scale)
          this.$bus.emit('set_path_anim', {action: 'undo', type: 'editMove', data: mid, pIndex: data.pIndex});
          break;
        case 'path_freePathType':
          this.$bus.emit('set_path_anim', {action: 'undo', type: 'freePathType', data: data.data});
          break;
        case 'path_savePath':
          scale = data.scale / this.TOOL.scale;
          mid = $.extend(true, {}, data.data)
          mid.target.h *= scale;
          mid.target.w *= scale;
          mid.target.x *= scale;
          mid.target.y *= scale;
          mid.info.width *= scale;
          mid.info.height *= scale;
          this._scaleArrTwo(mid.info.points, scale);
          //肯定为选中状态, 无需再次选中
          // ({scene, sprite} = this.select(data.scenesId, data.spriteId));
          this.$bus.emit('set_path_anim', {action: 'undo', type: 'savePath', data: mid});
          break;
        case 'path_dbToEdit':
          this.select(data.scenesId, data.spriteId);
          this.$bus.emit('set_path_anim', {action: 'edit'})
          break;
        case 'path_delPoint':
          this.$bus.emit('set_path_anim', {action: 'undo', type: 'redo_delPoint', pIndex: data.pIndex})
          break;
        case 'path_exitEdit':
          this.$bus.emit('set_path_anim', {action: 'close'})
          break;
        case 'camera_matrix':
          scene = this.TOOL.getScenesIdData(data.scenesId);
          scene.camera.updateCamera(data.cameraIndex, {
            matrix: {
              h: data.data.h * data.scale / this.TOOL.scale,
              w: data.data.w * data.scale / this.TOOL.scale,
              x: data.data.x * data.scale / this.TOOL.scale,
              y: data.data.y * data.scale / this.TOOL.scale,
            }
          })
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            this.TOOL.selectScenes(scene).then(() => {
              this.$store.commit('toggle_cameras', scene.camera.cameras);
            });
          } else {
            this.TOOL.selectSprite();
          }
          this.$store.commit('toggle_lensIndex', data.cameraIndex);
          this.$store.commit('toggle_lensEditState', true);
          break;
        case 'camera_add':
          scene = this.TOOL.getScenesIdData(data.scenesId);
          data.data.matrix = {};
          scene.camera.addCamera(data.data, data.cameraIndex);
          this.$store.commit('toggle_lensIndex', data.cameraIndex);
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            this.TOOL.selectScenes(scene).then(() => {
              this.$store.commit('toggle_lensEditState', true);
            });
          } else {
            this.TOOL.selectSprite();
            this.$store.commit('toggle_lensEditState', true);
          }
          break;
        case 'camera_delete':
          scene = this.TOOL.getScenesIdData(data.scenesId);
          scene.camera.delCamera(data.cameraIndex)
          this.$store.commit('toggle_lensIndex', -1);
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            this.TOOL.selectScenes(scene).then(() => {
              this.$store.commit('toggle_lensEditState', true);
            });
          } else {
            this.TOOL.selectSprite();
            this.$store.commit('toggle_lensEditState', true);
          }
          break;
        case 'camera_changeTime':
          scene = this.TOOL.getScenesIdData(data.scenesId);
          scene.camera.updateCamera(data.cameraIndex, {animations: data.data})
          this.$store.commit('toggle_lensIndex', data.cameraIndex);
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            this.TOOL.selectScenes(scene).then(() => {
              this.$store.commit('toggle_lensEditState', true);
            });
          } else {
            this.TOOL.selectSprite();
            this.$store.commit('toggle_lensEditState', true);
          }
          break;
        case 'timeline_drag':
          scene = this.TOOL.getScenesIdData(data.scenesId);
          data.changeData.forEach(info => {
            sprite = this.TOOL.findSpriteById(info.id);
            sprite.updateEffect(info.data)
          })
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            this.TOOL.selectScenes(scene)
          }
          break;
        case 'editor_resize':
          this.TOOL.setOptimized(data.type);
          this.TOOL.sprites.forEach(s => {
            if(s.camera.cameras.length) {
              s.camera._defaultC();
              s.camera.init()
            }
          });
          break;
        case 'formatBrush':
          this.TOOL.selectSprite();
          ({scene, sprite} = this.select(data.scenesId, data.spriteId));
          if(data.data.text) {
            sprite.artSetting({artType: data.data.text.artType})
            sprite.setversionAnyway(data.data.text.versionAnyway)
            sprite.updateSprite(data.data.text.option)
          }
          if(data.data.strokeSvg) {
            sprite.updateSprite(data.data.strokeSvg).then(() => {
              sprite.update(data.data.outward);
            })
          }else {
            sprite.update(data.data.outward);
          }
          if(data.reData.numberOfLoops) {
            if(sprite.type === 'Video') {
              sprite.setRepeatTimes(data.data.numberOfLoops);
            }else {
              sprite.setLoop(data.data.numberOfLoops)
            }
            sprite.setLoop(data.data.isLoop)
          }

          sprite.setBorder(data.data.border);
          sprite.setShadow(data.data.boxShadow);
          sprite.setShadow(data.data.dropShadow, 'dropShadow');
          sprite.setBgColor(data.data.bgColor);
          sprite.setFilter(data.data.filter);
          sprite.updateEffect(data.data.effect);
          break;
        case 'bgColor':
          ({scene, sprite} = this.select(data.scenesId, data.spriteId));
          sprite.setBgColor(data.data);
          break;
        case 'changeBorder':
          ({scene, sprite} = this.select(data.scenesId, data.spriteId));
          sprite.setBorder(data.data);
          break;
        case 'setShadow':
          ({scene, sprite} = this.select(data.scenesId, data.spriteId));
          sprite.setShadow(data.data.data, data.data.type);
          break;
        case 'richEdit':
          ({scene, sprite} = this.select(data.scenesId, data.spriteId));
          sprite.edited(data.data);
          break;
        case 'opacitys':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.data.length; i++) {
            sprite = this.TOOL.findSpriteById(data.data[i].id);
            sprite._opacity = null;
            sprite.opacity = data.data[i].opacity;
            sprite.changeStyle({ sync: true });
          }
          break;
        case 'volumes':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.data.length; i++) {
            sprite = this.TOOL.findSpriteById(data.data[i].id);
            if(sprite.type === 'Video') {
              sprite.setVolume(data.data[i].volume)
            } else {
              sprite.setSound({
                volume  : data.data[i].volume,
              })
            }
          }
          break;
        case 'setLoops':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.data.length; i++) {
            sprite = this.TOOL.findSpriteById(data.data[i].id);
            if(sprite.type === 'Video') {
              if(typeof (data.data[i].val) === 'boolean') {
                sprite.setLoop(data.data[i].val)
              } else {
                sprite.setRepeatTimes(data.data[i].val)
              }
            } else {
              sprite.setLoop(data.data[i].val)
            }
          }
          break;
        case 'textSettings':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.reData.length; i++) {
            sprite = this.TOOL.findSpriteById(data.reData[i].id);
            if(data.data.versionAnyway) {
              sprite.setversionAnyway(data.data.versionAnyway);
            }
            sprite.updateSprite(data.data);
          }
          break;
        case 'artSettings':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.data.length; i++) {
            sprite = this.TOOL.findSpriteById(data.data[i].id);
            if(data.data[i].effectCode) sprite.updateEffect({code: data.data[i].effectCode})
            sprite.artSetting(data.data[i]);
          }
          break;
        case 'bgColors':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.reData.length; i++) {
            sprite = this.TOOL.findSpriteById(data.reData[i].id);
            sprite.setBgColor(data.data.hex);
          }
          break;
        case 'setBorders':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.reData.length; i++) {
            sprite = this.TOOL.findSpriteById(data.reData[i].id);
            sprite.setBorder(data.data)
          }
          break;
        case 'setShadows':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.reData.length; i++) {
            sprite = this.TOOL.findSpriteById(data.reData[i].id);
            sprite.setShadow(data.data.shadow, data.data.type);
          }
          break;
        case 'setFilters':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.reData.length; i++) {
            sprite = this.TOOL.findSpriteById(data.reData[i].id);
            sprite.setFilter(data.data);
          }
          break;
        case 'updateEffects':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.data.length; i++) {
            sprite = this.TOOL.findSpriteById(data.data[i].id);
            sprite.updateEffect(data.data[i].data)
          }
          break;
        case 'layerSetting':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.data.length; i++) {
            sprite = this.TOOL.findSpriteById(data.data[i].id);
            sprite.zIndex = data.data[i].index;
            sprite.setIndex(data.data[i].index);
          }
          this.SelectScenes_Msg.sprites.sort(function (a, b) {
            return a.zIndex - b.zIndex;
          });
          break;
        case 'strokeWidths':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.reData.length; i++) {
            sprite = this.TOOL.findSpriteById(data.reData[i].id);
            sprite.updateSprite({strokeWidth: data.data})
          }
          break;
        case 'strokeColors':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.reData.length; i++) {
            sprite = this.TOOL.findSpriteById(data.reData[i].id);
            sprite.updateSprite({stroke: data.data})
          }
          break;
        case 'fillColors':
          if(this.SelectScenes_Msg.id !== data.scenesId) {
            scene = this.TOOL.getScenesIdData(data.scenesId);
            this.TOOL.selectScenes(scene);
          }
          for(let i=0; i < data.reData.length; i++) {
            sprite = this.TOOL.findSpriteById(data.reData[i].id);
            sprite.updateSprite({fill: data.data})
          }
          break;
        default:
          break;
      }
    },
    select(scenesId, spriteId) {
      let scene, sprite;
      if(this.SelectScenes_Msg.id !== scenesId) {
        scene = this.TOOL.getScenesIdData(scenesId);
        this.TOOL.selectScenes(scene);
      }
      sprite = this.TOOL.findSpriteById(spriteId);
      if(!this.SelectSprites_Msg[0] || this.SelectSprites_Msg[0] && this.SelectSprites_Msg[0].id !== spriteId) {
        this.TOOL.selectSprite([sprite]);
      }
      return {
        scene: scene,
        sprite: sprite
      }
    },
    _scaleArr: function(arr, scale) {
      if(!arr || scale === 1) return arr;
      for (var i = 0; i < arr.length; i++ ) {
        arr[i] *= scale
      }
      return arr;
    },
    _scaleArrTwo: function(arr, scale) {
      if(!arr || scale === 1) return arr;
      for (var i = 0; i < arr.length; i++ ) {
        arr[i].forEach(function(v, j) {
          arr[i][j] = v *= scale
        })
      }
      return arr;
    },
    canUndoRedo() {
      this.canUndo = this['stack' + this.type].canUndo();
      this.canRedo = this['stack' + this.type].canRedo();
      this.$bus.emit('checkUndoButton', {
        canUndo: this.canUndo,
        canRedo: this.canRedo
      });
    },
    inStackPath(data) {
      // 路径动画入栈
      this.stackPath.execute(new this.editCommandPath(data.type, data.data, this.fn));
      this.canUndoRedo();
    },
    undoPath() {
      this.stackPath.undo();
      this.canUndoRedo();
    },
    redoPath() {
      this.stackPath.redo();
      this.canUndoRedo();
    },
    onUndoRedoClear () {
      this.stack.clearStack();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/undo/undo.vue